import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { MobileMenu } from './components/MobileMenu';
import { CouponModal } from './components/CouponModal';
import { Notification } from './components/Notification';
import { SavedCoupons } from './components/SavedCoupons';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { UserProgress } from './components/UserProgress';
export function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [savedCoupons, setSavedCoupons] = useState<any[]>([]);
  const [selectedCoupon, setSelectedCoupon] = useState<any>(null);
  const [notification, setNotification] = useState({
    show: false,
    message: ''
  });
  const [showSavedCoupons, setShowSavedCoupons] = useState(false);
  const [showUserDashboard, setShowUserDashboard] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [activeCategory, setActiveCategory] = useState('groceries');
  const toggleSaveCoupon = (coupon: any) => {
    const isSaved = savedCoupons.some(saved => saved.id === coupon.id);
    if (isSaved) {
      setSavedCoupons(savedCoupons.filter(saved => saved.id !== coupon.id));
      showNotification(`Removed "${coupon.brand || coupon.title}" from saved coupons`);
    } else {
      setSavedCoupons([...savedCoupons, coupon]);
      showNotification(`Saved "${coupon.brand || coupon.title}" to your coupons`);
    }
  };
  const showNotification = (message: string) => {
    setNotification({
      show: true,
      message
    });
    setTimeout(() => setNotification({
      show: false,
      message: ''
    }), 3000);
  };
  const handleSearch = (query: string) => {
    setSearchQuery(query);
  };
  return <Router data-id="element-0">
      <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-1">
        <Header onMenuToggle={() => setMobileMenuOpen(!mobileMenuOpen)} savedCount={savedCoupons.length} onSavedClick={() => setShowSavedCoupons(true)} onSearch={handleSearch} onDashboardClick={() => setShowUserDashboard(true)} data-id="element-2" />
        <Routes data-id="element-3">
          <Route path="/" element={<HomePage onCouponClick={setSelectedCoupon} onSaveCoupon={toggleSaveCoupon} savedCoupons={savedCoupons} searchQuery={searchQuery} activeCategory={activeCategory} onCategoryChange={setActiveCategory} data-id="element-5" />} data-id="element-4" />
          <Route path="/about" element={<AboutPage data-id="element-7" />} data-id="element-6" />
          <Route path="*" element={<Navigate to="/" data-id="element-9" />} data-id="element-8" />
        </Routes>
        <Footer data-id="element-10" />
        {mobileMenuOpen && <MobileMenu onClose={() => setMobileMenuOpen(false)} savedCount={savedCoupons.length} onSavedClick={() => {
        setShowSavedCoupons(true);
        setMobileMenuOpen(false);
      }} onDashboardClick={() => {
        setShowUserDashboard(true);
        setMobileMenuOpen(false);
      }} data-id="element-11" />}
        {selectedCoupon && <CouponModal coupon={selectedCoupon} onClose={() => setSelectedCoupon(null)} onSave={() => toggleSaveCoupon(selectedCoupon)} isSaved={savedCoupons.some(saved => saved.id === selectedCoupon.id)} data-id="element-12" />}
        {notification.show && <Notification message={notification.message} data-id="element-13" />}
        {showSavedCoupons && <SavedCoupons coupons={savedCoupons} onClose={() => setShowSavedCoupons(false)} onCouponClick={setSelectedCoupon} onRemove={toggleSaveCoupon} data-id="element-14" />}
        {showUserDashboard && <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-15">
            <div className="bg-white rounded-xl w-full max-w-md max-h-[90vh] overflow-auto" data-id="element-16">
              <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-17">
                <h2 className="text-xl font-bold" data-id="element-18">Your Dashboard</h2>
                <button className="p-2 rounded-full hover:bg-gray-100" onClick={() => setShowUserDashboard(false)} data-id="element-19">
                  <span className="text-xl" data-id="element-20">&times;</span>
                </button>
              </div>
              <div className="p-4" data-id="element-21">
                <UserProgress data-id="element-22" />
              </div>
            </div>
          </div>}
      </div>
    </Router>;
}